module.exports = __webpack_public_path__ + "img/bgcenter.d5e6f475.png";